import Grid from "@material-ui/core/Grid";
import {
  StyledComponentProps,
  StyleRulesCallback,
  Theme,
  withStyles,
} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import * as React from "react";
import {
  Cell,
  Curve,
  Legend,
  Pie,
  PieChart as PieChartRecharts,
  PieLabelRenderProps,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

import ProgressOverlay from "../ProgressOverlay";

interface Props {
  colorScheme: string[];
  data: Array<{ value: number; label: string }>;
  loading: boolean;
  title?: string;
  showLegend?: true;
  showTooltip?: true;
  tooltipFormatter?: (value: number) => string;
  id?: string;
}

class PieChart extends React.Component<Props & StyledComponentProps> {
  private percentageThresholdForLabels = 5;
  private showLabelOnlyAbovePercentageThreshold = (
    props: PieLabelRenderProps
  ): string | null => {
    // In PieCharts "percent" is actually a fraction of 1, therefore division by 100.
    // This solution to crop labels depending on the pie chart container size is a bit hacky and could be improved.
    if (
      props.percent &&
      props.percent > this.percentageThresholdForLabels / 100
    ) {
      const pieChartContainerElement = document.querySelector(
        `#${this.props.id}`
      );
      if (
        pieChartContainerElement &&
        pieChartContainerElement.clientWidth < 800
      ) {
        const maxLengthLabelString =
          (30 * pieChartContainerElement.clientWidth) / 800;
        return props.label.length > maxLengthLabelString
          ? props.label.slice(0, maxLengthLabelString - 3) + "..."
          : props.label;
      } else {
        return props.label;
      }
    } else {
      return null;
    }
  };
  private showLabelLineOnlyAbovePercentageThreshold = (props: any): any =>
    // In PieCharts "percent" is actually a fraction of 1, therefore division by 100.
    props.percent && props.percent > this.percentageThresholdForLabels / 100 ? (
      <Curve {...props} type="linear" />
    ) : (
      false
    );

  public render() {
    return (
      <ProgressOverlay loading={this.props.loading}>
        <Grid container={true} spacing={2}>
          {this.props.title && (
            <Grid item={true} xs={12}>
              <Typography variant="h6">{this.props.title}</Typography>
            </Grid>
          )}
          <Grid item={true} xs={12}>
            <Typography component="div">
              <ResponsiveContainer id={this.props.id} width="100%" height={300}>
                <PieChartRecharts>
                  <Pie
                    data={this.props.data}
                    dataKey="value"
                    nameKey="label"
                    innerRadius="50%"
                    label={this.showLabelOnlyAbovePercentageThreshold}
                    labelLine={this.showLabelLineOnlyAbovePercentageThreshold}
                    outerRadius="80%"
                    paddingAngle={1}
                  >
                    {this.props.data.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={
                          this.props.colorScheme[
                            index % this.props.colorScheme.length
                          ]
                        }
                      />
                    ))}
                  </Pie>
                  {this.props.showTooltip && (
                    <Tooltip formatter={this.props.tooltipFormatter} />
                  )}
                  {this.props.showLegend && <Legend />}
                </PieChartRecharts>
              </ResponsiveContainer>
            </Typography>
          </Grid>
        </Grid>
      </ProgressOverlay>
    );
  }
}

const styles: StyleRulesCallback<Theme, Props> = (theme: Theme) => ({});

export default withStyles(styles)(PieChart);



// WEBPACK FOOTER //
// ./src/components/generic/PieChart.tsx